import * as stylex from "@stylexjs/stylex";
import { colors } from "../../../materials/consts.stylex";
// StyleX's compiler requires `stylex.create()` spread arguments to be a
// static object expression written inline — spreading a font preset imported
// from another file isn't supported. So each font-dependent key here holds
// only its residual (non-font) properties; call sites combine it with the
// matching preset from `materials/typography.stylex.ts`, e.g.
// `stylex.props(typography.axis, lineChartDefaultStyles.axisLabel)`. See the
// per-key mapping below.
//
// columnTitle -> typography.table   annotationText -> typography.meta
// axisLabel   -> typography.axis    value           -> typography.meta
// axisYLine   -> (no font)          valueMini       -> typography.table (no residual properties)
// axisXLine   -> (no font)          label           -> typography.meta
// annotationLine -> (no font)       title           -> typography.meta
// annotationBand -> (no font)       bandLegend      -> typography.meta
// annotationBandLabel -> typography.axis             bandBar -> (no font)
// svgOverflowVisible -> (no font)                    svgOverflowHidden -> (no font)
export const lineChartDefaultStyles = {
    columnTitle: {
        kDwRjp: "x6ii1vp",
        $$css: true
    },
    axisLabel: {
        kDwRjp: "x13ylgtg",
        $$css: true
    },
    axisYLine: {
        kjVXCG: "x1q4kd6z",
        kfJifR: "x1eds3jc",
        kUyJAE: "xc03x0k",
        $$css: true
    },
    axisXLine: {
        kjVXCG: "x1q4kd6z",
        kfJifR: "x1eds3jc",
        kUyJAE: "xc03x0k",
        $$css: true
    },
    annotationLine: {
        kDwRjp: "xjqwmh7",
        kjVXCG: "xqvyd8v",
        kfJifR: "xnpr05h",
        $$css: true
    },
    annotationBand: {
        kWkggS: "x42x0ya",
        kSiTet: "x1wwuglj",
        $$css: true
    },
    annotationBandLabel: {
        kDwRjp: "x13ylgtg",
        kCrYw0: "x1x0jnz8",
        kjVXCG: "xqvyd8v",
        kfJifR: "xnpr05h",
        kU5bRw: "x5lxx2x",
        kJdQPc: "x1bivah8",
        $$css: true
    },
    annotationText: {
        k63SB2: "x117nqv4",
        kDwRjp: "xjqwmh7",
        kCrYw0: "x1x0jnz8",
        kjVXCG: "xqvyd8v",
        kfJifR: "xnpr05h",
        kU5bRw: "x5lxx2x",
        kJdQPc: "x1bivah8",
        $$css: true
    },
    value: {
        kDwRjp: "x13ylgtg",
        $$css: true
    },
    valueMini: {
        $$css: true
    },
    label: {
        kDwRjp: "x13ylgtg",
        kCrYw0: "x1x0jnz8",
        kjVXCG: "xqvyd8v",
        kfJifR: "xb090w",
        kU5bRw: "x5lxx2x",
        kJdQPc: "x1bivah8",
        $$css: true
    },
    title: {
        k63SB2: "x117nqv4",
        kDwRjp: "x6ii1vp",
        kCrYw0: "x1x0jnz8",
        kjVXCG: "xqvyd8v",
        kfJifR: "xb090w",
        kU5bRw: "x5lxx2x",
        kJdQPc: "x1bivah8",
        $$css: true
    },
    bandLegend: {
        kDwRjp: "x13ylgtg",
        khDVqt: "xuxw1ft",
        $$css: true
    },
    bandBar: {
        k1xSpc: "x1rg5ohu",
        kzqmXN: "xvy4d1p",
        kZKoxP: "x6w4g8m",
        k1K539: "x1jyxor1",
        kWkggS: "xadepuf",
        kEafiO: "x1gp4ovq",
        kPef9Z: "x13fuv20",
        kLZC3w: "xaxvwvn",
        kt9PQ7: "x1h2mt7u",
        kfdmCh: "x1q0q8m5",
        kL6WhQ: "x18fk0n2",
        $$css: true
    },
    svgOverflowVisible: {
        kVQacm: "x1rea2x4",
        $$css: true
    },
    svgOverflowHidden: {
        kVQacm: "xb3r6kr",
        $$css: true
    }
};
